export const undefault = (content: any) => content?.default ?? content;
